import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";

function OutgoingStatisticsModal({ title, onClose, originRows, selectDataID, keyword, tabID }) {
  const appStore = useContext(AppContext);
  const [tabPanelHeight, setTabPanelHeight] = useState(400);
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [modalTabID, setModalTabID] = useState('1');

  const handleSetting = () => {
    // 데이터 정리

    if(tabID === "1") { // 출하처
      setDataColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
        { field: 'partner_name', headerName: '출하처', width: 150, headerAlign: 'center', align:'left' },
        { field: 'outgoing_date', headerName: '출하일', width: 100, headerAlign: 'center', align:'center'},
        { field: 'outgoing_number', headerName: '출하번호', width: 110, headerAlign: 'center', align:'center' },
        { field: 'outgoing_item_name', headerName: '품목명', width: 150, headerAlign: 'center', align:'left'},
        { field: 'outgoing_item_spec', headerName: '규격', width: 260, headerAlign: 'center', align:'left'},
        { field: 'outgoing_item_count', headerName: '출하수량', width: 100, headerAlign: 'center', align:'right'}
      ]);
    } else if(tabID === "2") { // 품목
      setDataColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
        { field: 'outgoing_partner_name', headerName: '출하처', width: 150, type: 'nubmer', headerAlign: 'center', align:'left' },
        { field: 'outgoing_date', headerName: '출하일', width: 100, headerAlign: 'center', align:'center'},
        { field: 'outgoing_number', headerName: '출하번호', width: 110, headerAlign: 'center', align:'center' },
        { field: 'item_name', headerName: '품목명', width: 150, headerAlign: 'center', align:'left' },
        { field: 'item_spec', headerName: '규격', width: 260, headerAlign: 'center' },
        { field: 'outgoing_item_count', headerName: '출하수량', width: 100, headerAlign: 'center', align:'right'}
      ]);
    } else { // 일별, 월별
      setDataColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
        { field: 'outgoing_partner_name', headerName: '출하처', width: 150, headerAlign: 'center' },
        { field: 'outgoing_date', headerName: '출하일', width: 100, headerAlign: 'center', align:'center'},
        { field: 'outgoing_number', headerName: '출하번호', width: 110, headerAlign: 'center', align:'center' },
        { field: 'outgoing_item_name', headerName: '품목', width: 150, headerAlign: 'center' },
        { field: 'outgoing_item_spec', headerName: '규격', width: 260, headerAlign: 'center' },
        { field: 'outgoing_item_count', headerName: '출하수량', width: 100, headerAlign: 'center', align:'right'}
      ]);
    }
  }

  const [dataColumnVisibilityModel, setDataColumnVisibilityModel] = useState({
    id: false,
    outgoing_number: true,
    outgoing_date: true,
    partner_name: true,
    partner_number: true,
    outgoing_item_count: true,
    outgoing_item_name: true,
    outgoing_item_spec: true
  });

  const handleInitSelect = () => {

    if(tabID === "1"){

        var tempData = originRows.filter((item, index) => {
          return typeof item.partner_id !== 'undefined' && item.partner_id === selectDataID;
        });

        tempData = tempData.sort(function(a, b) { 
          return a.outgoing_item_name < b.outgoing_item_name ? -1 : a.outgoing_item_name > b.outgoing_item_name ? 1 : 0;
        });
        tempData = tempData.sort(function(a, b) { 
          return a.outgoing_number > b.outgoing_number ? -1 : a.outgoing_number < b.outgoing_number ? 1 : 0;
        });
        tempData = tempData.sort(function(a, b) { 
          return a.partner_name < b.partner_name ? -1 : a.partner_name > b.partner_name ? 1 : 0;
        });

        setDataRows(tempData.map((item, index) => ({
          id: index,
          outgoing_number: item.outgoing_number,
          outgoing_date: item.outgoing_date,
          partner_name: item.partner_name,
          partner_number: item.partner_number,
          outgoing_item_count: item.outgoing_item_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          outgoing_item_name: item.outgoing_item_name,
          outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.outgoing_item_spec, item.item_width, item.item_depth, item.item_height)        })));

    }else if(tabID === "2"){

        var tempData = originRows.filter((item, index) => {
          return typeof item.item_id !== 'undefined' && item.item_id === selectDataID;
        });

        tempData = tempData.sort(function(a, b) { 
          return a.item_name < b.item_name ? -1 : a.item_name > b.item_name ? 1 : 0;
        });
        tempData = tempData.sort(function(a, b) { 
          return a.outgoing_number > b.outgoing_number ? -1 : a.outgoing_number < b.outgoing_number ? 1 : 0;
        });
        tempData = tempData.sort(function(a, b) { 
          return a.outgoing_partner_name < b.outgoing_partner_name ? -1 : a.outgoing_partner_name > b.outgoing_partner_name ? 1 : 0;
        });
        
        setDataRows(tempData.map((item, index) => ({
          id: index,
          outgoing_number: item.outgoing_number,
          outgoing_date: item.outgoing_date,
          item_name: item.item_name,
          item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
          outgoing_partner_name: item.outgoing_partner_name,
          outgoing_item_count: item.outgoing_item_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        })));
        
    }else{

      var tempData = []

      if(tabID === "3"){ // 일별

        tempData = originRows.filter((item, index) => {
          return typeof item.outgoing_date !== 'undefined' && item.outgoing_date === selectDataID;
        });

      }else if(tabID === "4"){ // 월별

        tempData = originRows.filter((item, index) => {
          return typeof item.month_data !== 'undefined' && item.month_data === selectDataID;
        });

      }

      tempData = tempData.sort(function(a, b) { 
        return a.outgoing_item_name < b.outgoing_item_name ? -1 : a.outgoing_item_name > b.outgoing_item_name ? 1 : 0;
      });
      tempData = tempData.sort(function(a, b) { 
        return a.outgoing_number > b.outgoing_number ? -1 : a.outgoing_number < b.outgoing_number ? 1 : 0;
      });
      tempData = tempData.sort(function(a, b) { 
        return a.outgoing_partner_name < b.outgoing_partner_name ? -1 : a.outgoing_partner_name > b.outgoing_partner_name ? 1 : 0;
      });

      setDataRows(tempData.map((item, index) => ({
        id: index,
        outgoing_date: item.outgoing_date,
        outgoing_number: item.outgoing_number,
        outgoing_partner_name: item.outgoing_partner_name,
        outgoing_item_name: item.outgoing_item_name,
        outgoing_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.outgoing_item_spec, item.item_width, item.item_depth, item.item_height),
        outgoing_item_count: item.outgoing_item_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      })));

    }

  };

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setTabPanelHeight(400);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  const handleTabID = (event, newTabID) => {
    setModalTabID(newTabID);
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={modalTabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="상세통계" value="1" />
              </TabList>
            </Box>
            <TabPanel value="1" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={dataRows}
                  columns={dataColumns}
                  columnVisibilityModel={dataColumnVisibilityModel}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default OutgoingStatisticsModal;